document.addEventListener('alpine:init', () => {
  Alpine.store('overlays', {
    overlays: {},

    // Toggle: if undefined, initialize as false and then toggle
    toggle(id) {
      this.overlays[id] = !this.overlays[id];
    },

    // Open: sets overlay[id] = true
    open(id) {
      this.overlays[id] = true;
    },

    // Close: sets overlay[id] = false
    close(id) {
      this.overlays[id] = false;
    },

    // Check if any overlay is open
    anyOpen() {
      return Object.values(this.overlays).some(Boolean);
    },

    // Check if specific overlay is open
    isOpen(id) {
      return !!this.overlays[id];
    },
  });

  Alpine.effect(() => {
    document.body.classList.toggle('overflow-hidden', Alpine.store('overlays').anyOpen());
  });
});
